import React from 'react';
import { makeStyles } from '@mui/styles';

import { GridOverlay } from '@mui/x-data-grid-pro';

import Fade from '@mui/material/Fade';
import CircularProgress from '@mui/material/CircularProgress';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import PollIcon from '@mui/icons-material/Poll';
import noResults from '../../../images/no-results.png';

const useStyles = makeStyles(theme => ({
    root: {
        flexDirection: 'column',
    },
    label: {
        marginTop: theme.spacing(1),
    },
    image: {
        width: '132px',    // Set fixed width to 132px
        height: '132px',   // Set fixed height to 132px
        objectFit: 'contain', // Maintain aspect ratio and fit inside the box
        maxWidth: '300px',
        minWidth: '100px',
    },
}));

// placeholders: there's much more we can do here
function LoadingOverlay () {
    return <GridOverlay> <CircularProgress color="secondary"/> </GridOverlay>;
}

// this guy needs a delay so we don't add the overlay while the table is rendering
function NoRowsOverlay () {
    const classes = useStyles();
    return (
        <Fade in={true} timeout={4200}>
            <div>
                <GridOverlay className={classes.root}>
                    <img src={noResults} alt="No Results" className={classes.image}/>
                    {/* <SentimentVeryDissatisfiedIcon fontSize={'large'} color="secondary"/> */}
                    <div className={classes.label}>No Results</div>
                </GridOverlay>
            </div>
        </Fade>
    );
}

// this guy needs a delay so we don't add the overlay while the table is rendering
function NoCMCLoadingOverlay () {
    const classes = useStyles();
    return (
        <Fade in={true} timeout={4200}>
            <div>
                <GridOverlay className={classes.root}>
                    <PollIcon fontSize={'large'} color="secondary"/>
                    <div className={classes.label}>Please Select CMC</div>
                </GridOverlay>
            </div>
        </Fade>
    );
}

export { LoadingOverlay, NoRowsOverlay, NoCMCLoadingOverlay };
